var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('employer-notes',{attrs:{"employer_id":_vm.employerId,"type":"note"}}),_vm._v(" "),_c('employer-notes',{attrs:{"employer_id":_vm.employerId,"type":"score"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }